import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const painPoints = [{
    icon: '😤',
    title: 'La pantalla en blanco',
    desc: 'Llevas horas intentando crear un post. Escribes algo, lo borras. Terminas publicando cualquier cosa mediocre.'
  }, {
    icon: '🤖',
    title: 'ChatGPT suena a robot',
    desc: 'Usaste la IA y te devolvió texto genérico lleno de "fascinante" y "revolucionario". Frustrante y poco útil.'
  }, {
    icon: '⏰',
    title: 'Sin tiempo para todo',
    desc: 'Pasas el 70% de tu semana en contenido y solo el 30% en lo que realmente genera dinero: tus clientes.'
  }, {
    icon: '📉',
    title: 'Inconsistencia constante',
    desc: 'Publicas 3 días seguidos y luego desapareces 2 semanas. El algoritmo te penaliza. La audiencia te olvida.'
  }, {
    icon: '😰',
    title: 'Tu competencia te gana',
    desc: 'Alguien con menos experiencia que tú publica todos los días y crece. Tú sabes más, pero ellos aparecen más.'
  }, {
    icon: '💸',
    title: 'Pagar por ayuda no es opción',
    desc: 'Un community manager cuesta $800-2000/mes. Una agencia, $2000+. No tiene sentido cuando recién estás escalando.'
  }];
  return <section className="py-28 px-6 bg-darker text-center" data-id="element-218">
      <div className="max-w-[1000px] mx-auto" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-220">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-221">
            ¿Te identificas?
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-4 max-w-[700px] mx-auto text-white" data-id="element-222">
            El problema que nadie
            <br data-id="element-223" />
            te está diciendo
          </h2>
          <p className="text-lg text-[#AAAAAA] max-w-[600px] mx-auto mb-[60px]" data-id="element-224">
            No es falta de creatividad. No es falta de tiempo. Es falta de
            sistema.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-[60px]" data-id="element-225">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="bg-cardBg border border-border rounded-2xl p-7 text-left transition-all duration-300 hover:border-[rgba(255,107,0,0.3)] hover:-translate-y-1" data-id="element-226">
              <span className="text-[32px] mb-4 block" data-id="element-227">{point.icon}</span>
              <h3 className="text-lg font-bold mb-2.5 text-white" data-id="element-228">
                {point.title}
              </h3>
              <p className="text-[15px] text-[#888] leading-[1.6]" data-id="element-229">
                {point.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[rgba(255,107,0,0.1)] to-[rgba(255,107,0,0.05)] border border-[rgba(255,107,0,0.3)] rounded-2xl p-10 max-w-[700px] mx-auto" data-id="element-230">
          <p className="text-[20px] font-semibold leading-[1.7] text-white" data-id="element-231">
            <strong className="text-orange" data-id="element-232">La verdad incómoda:</strong> El
            problema nunca fue la creatividad. Fue que nadie te dio un proceso
            de producción. Los creadores que publican todos los días no son más
            talentosos —
            <strong className="text-orange" data-id="element-233">
              {' '}
              solo tienen una fábrica que tú todavía no tienes.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}